import backend from '@api/backend'
import { useQuery } from '@tanstack/react-query'
import { MailTemplate } from '@data/mail/model/mail'

export const useMailTemplateById = (id: string) => {
  return useQuery<MailTemplate>({
    queryKey: ['mailTemplate', id],
    queryFn: ({signal}) => getById(id, signal),
    enabled: true,
    staleTime: 1000 * 60 * 2, // 60 minutes,
  })
}

const getById = async (id: string, signal: AbortSignal): Promise<MailTemplate> => {
  const response = await backend.get(`/mail_templates/${id}`, {
    signal,
  })
  return response.data
}
